import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { Button } from '@/common/ui/button'
import { useState } from 'react'
import useQueryGetDynamicSection from '@/modules/client-setting/api/hooks/useQueryGetDynamicSection'
import useMutationAddSectionToPage from '@/modules/client-setting/api/hooks/useMutationAddSectionToPage'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { DynamicPageQueryKeys } from '@/modules/client-setting/keys'
import { useQueryClient } from '@tanstack/react-query'

interface AddSectionToPageModalProps {
	pageId: string
}

export default function AddSectionToPageModal({
	pageId,
}: AddSectionToPageModalProps) {
	const [selectedSectionId, setSelectedSectionId] = useState<string>('')
	const [isOpen, setIsOpen] = useState(false)
	const queryClient = useQueryClient()

	const { data: sections } = useQueryGetDynamicSection({
		skip: 0,
		take: 100,
	})

	const { mutate: addSection, isPending } = useMutationAddSectionToPage({
		onSuccess: () => {
			toast.success('เพิ่ม section สำเร็จ')
			setIsOpen(false)
			setSelectedSectionId('')
			queryClient.invalidateQueries({
				queryKey: [DynamicPageQueryKeys.GetDynamicPageById, pageId],
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleAddSection = () => {
		if (!pageId || !selectedSectionId) return
		addSection({
			payload: {
				pageId,
				sectionId: selectedSectionId,
			},
		})
	}

	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogTrigger asChild>
				<Button variant="default">เพิ่ม section</Button>
			</DialogTrigger>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>เพิ่ม section</DialogTitle>
				</DialogHeader>
				<div className="space-y-4">
					<Select
						value={selectedSectionId}
						onValueChange={setSelectedSectionId}
					>
						<SelectTrigger>
							{selectedSectionId ? (
								<SelectValue />
							) : (
								<span className="text-muted-foreground">เลือก section</span>
							)}
						</SelectTrigger>
						<SelectContent>
							{sections?.data.map((section) => (
								<SelectItem key={section.id} value={section.id}>
									{section.name}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
					<Button
						onClick={handleAddSection}
						disabled={!selectedSectionId || isPending}
					>
						{isPending ? 'กำลังเพิ่ม...' : 'เพิ่ม'}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
